<template>
  <h2 class="text-info display-5">Todays Winners!</h2>
  <div
    v-if="getCurrentWinners"
    class="col-md-8 offset-md-2 transparentbox mb-3"
  >
    <!-- <ConfettiComponent ref="ConfettiComponent" /> -->

    <h2 class="text-primary display-6">
      {{ getCurrentWinners.prize.name }}
    </h2>
    <div class="fading-slider">
      <transition name="fade" mode="out-in">
        <div :key="currentIndex + '-' + currentPrizeIndex" class="slider-item">
          <h1 class="text-light display-2">
            {{ getCurrentWinners.winner_names[currentIndex] }}
          </h1>
        </div>
      </transition>
    </div>
  </div>

  <div
    v-if="getCurrentConsolationWinners"
    class="col-md-8 offset-md-2 transparentbox mb-3"
  >
    <div class="mb-3">
      <h5 class="text-primary display-6">
        {{ getCurrentConsolationWinners.consolation_prize.name }}
      </h5>
      <span
        class="text-light display-6"
        v-for="(winnername, index) in getCurrentConsolationWinners.winner_names"
        v-bind:key="winnername"
      >
        {{ winnername
        }}<span
          v-if="index < getCurrentConsolationWinners.winner_names.length - 1"
          >,
        </span>
      </span>
    </div>
  </div>

  <div
    v-if="!getCurrentWinners && !getCurrentConsolationWinners"
    class="col-md-8 offset-md-2 transparentbox mb-3"
  >
    <h3 class="text-light">No winners available yet!</h3>
  </div>
</template>

<script>
// import ConfettiComponent from "./ConfettiComponent.vue";

export default {
  name: "WinnerSlider",
  components: {
    // ConfettiComponent,
  },
  created() {
    this.$store.dispatch("fetchWinners");
  },
  computed: {
    getAllCurrentWinners() {
      let winners = this.$store.getters.getWinners;
      return winners.filter(
        (winner) => winner.winner_state === "current" && winner.prize !== null
      );
    },
    getAllCurrentConsolationWinners() {
      let winners = this.$store.getters.getWinners;
      return winners.filter(
        (winner) =>
          winner.winner_state === "current" && winner.consolation_prize !== null
      );
    },
    getCurrentWinners() {
      if (this.getAllCurrentWinners.length === 0) return null;
      return this.getAllCurrentWinners[this.currentPrizeIndex];
    },
    getCurrentConsolationWinners() {
      if (this.getAllCurrentConsolationWinners.length === 0) return null;
      return this.getAllCurrentConsolationWinners[
        this.currentConsolationPrizeIndex
      ];
    },
    totalWinnerNames() {
      if (!this.getCurrentWinners) return 0;
      return this.getCurrentWinners.winner_names.length;
    },
  },
  data() {
    return {
      currentIndex: 0, // Tracks the current winner name
      currentPrizeIndex: 0, // Tracks the current prize
      currentConsolationPrizeIndex: 0, // Tracks the current consolation prize
    };
  },
  mounted() {
    this.startSlideshow();
    // this.$refs.ConfettiComponent.startConfetti();
  },
  beforeUnmount() {
    clearInterval(this.interval); // Clear interval when the component is destroyed
  },
  methods: {
    startSlideshow() {
      this.interval = setInterval(() => {
        if (this.getAllCurrentWinners.length === 0) return;

        const currentWinners = this.getCurrentWinners;
        if (!currentWinners) return;

        // Move to next winner name
        this.currentIndex++;

        // If we've shown all winners for this prize, move to next prize
        if (this.currentIndex >= currentWinners.winner_names.length) {
          this.currentIndex = 0;
          this.currentPrizeIndex =
            (this.currentPrizeIndex + 1) % this.getAllCurrentWinners.length;
        }

        // Also cycle consolation prizes
        if (this.getAllCurrentConsolationWinners.length > 0) {
          this.currentConsolationPrizeIndex =
            (this.currentConsolationPrizeIndex + 1) %
            this.getAllCurrentConsolationWinners.length;
        }
      }, 3000); // Change item every 3 seconds
    },
  },
};
</script>

<style>
.fading-slider {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin: 20px;
  height: 50px; /* Adjust to match content */
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-item {
  display: inline-block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
